<script>
import MainTable from '@/components/price-managment/MainTable'
import VariantTable from '@/components/price-managment/VariantTable'
import EditMarketModal from '@/components/price-managment/modals/EditMarket.vue'
import {
    getLoadMarketPlacesRequest,
    setMarketPercentageRequest
} from "@/api/product";
export default {
    components: { MainTable, VariantTable, EditMarketModal },
    props: {
        locale: null
    },
    data() {

        return {
            isMainTable: true,
            langLoaded: false,
            marketPlaces: [],
            filters: [],
            pageSettings:{}
        };
    },
    mounted() {
        this.$i18n.locale = this.locale
        if (this.$i18n.locale == "en") {
            localStorage.setItem("lang", "en");
        } else {
            localStorage.setItem("lang", "ar");
        }

        this.setFilters();
        this.setPageSettings();
        const getMarketPlaces = this.getMarketPlaces;
        $(() => {
            $('.edit-market-btn').on('click', () => {
                getMarketPlaces()
            })
        })

    },
    watch: {
        locale() {
        }
    },
    methods: {
        loadSvg(fileName) {
            return window.location.origin + '/assets/image/' + fileName
        },
        setPageSettings(){
            this.pageSettings = {
                title: this.$t('priceManagment'),
                breadCrumbs:[
                    {
                        href:window.location.origin+'/'+this.locale,
                        label:this.$t('home')
                    },
                    {
                        href:window.location.href,
                        label:this.$t('priceManagment')
                    }
                ]
            }
        },
        setFilters() {
            this.filters = [{
                type: 'text',
                label: this.$t('productSearch'),
                name: 'title'
            },
            {
                type: 'text',
                label: this.$t('sku'),
                name: 'sku'
            },
            {
                type: 'number',
                label: this.$t('priceLT'),
                name: 'to_price'
            },
            {
                type: 'number',
                label: this.$t('priceGT'),
                name: 'from_price'
            },
            {
                type: 'number',
                label: this.$t('quantityLT'),
                name: 'to_quantity'
            },
            {
                type: 'number',
                label: this.$t('quantityGT'),
                name: 'from_quantity'
            },
            {
                type: 'select',
                label: this.$t('category'),
                name: 'category',
                options: [],
                settings: {
                    ajax: {
                        url: process.env.MIX_API_URL + 'resources/categories',
                        dataType: 'json'
                    }
                }
            },
            {
                type: 'select',
                label: this.$t('manufacturer'),
                name: 'manufacturer',
                options: [],
                settings: {
                    ajax: {
                        url: process.env.MIX_API_URL + 'resources/manufacturer',
                        dataType: 'json'
                    }
                }
            },
            {
                type: 'select',
                label: this.$t('marketPlaces'),
                name: 'marketplace',
                options: [],
                settings: {
                    ajax: {
                        url: process.env.MIX_API_URL + 'resources/marketplaces',
                        dataType: 'json'
                    }
                }
            },
            {
                type: 'select',
                label: this.$t('status'),
                name: 'status',
                options: [{
                    id: "all",
                    text: this.$t('all')
                },
                {
                    id: "active",
                    text: this.$t('active')
                },
                {
                    id: "disabled",
                    text: this.$t('disabled')
                }],
                settings: {}
            },
            // {
            //     type: 'text',
            //     label: this.$t('tags'),
            //     name: 'tags'
            // }
            ]
        },
        updateMarket(form) {
            this.showLoading = true;
            this.ApiService(setMarketPercentageRequest(form))
                .then(({ data }) => {
                    if (data.status == 200)
                        swalToastFire('success', data.message);
                    if (data.status == 400)
                        swalToastFire('error', data.message);
                })
                .finally(() => {
                    this.showLoading = false;
                });
        },
        getMarketPlaces() {
            this.ApiService(getLoadMarketPlacesRequest())
                .then(({ data }) => {
                    this.marketPlaces = data.data
                })
                .finally(() => {
                    this.showLoading = false;
                });
        }
    },
};
</script>

<template>
    <tool-bar :filters="filters" :pageSettings="pageSettings" ></tool-bar>

    <div id="kt_content_container" class="d-flex flex-column-fluid align-items-start container-xxl">
        <div class="content flex-row-fluid" id="kt_content">
            <div class="card">
                <div class="card-header border-0 pt-6">
                    <!--begin::Card title-->
                    <div class="col-lg-7 col-md-4 col-sm-12">
                        <!--begin::Search-->
                        <div class="d-flex align-items-center position-relative my-1">
                            <span class="svg-icon svg-icon-1 position-absolute ms-6">
                                <img :src="loadSvg('search-icon.svg')" />
                            </span>
                            <input v-if="isMainTable" type="text" data-kt-docs-table-filter="product-search"
                                class="form-control form-control-solid w-250px ps-14" :placeholder="$t('productSearch')"
                                value="" autocomplete="off" />
                            <input v-else type="text" data-kt-docs-table-filter="variant-search"
                                class="form-control form-control-solid w-250px ps-14" :placeholder="$t('variantSearch')"
                                value="" autocomplete="off" />
                        </div>
                        <!--end::Search-->
                    </div>
                    <!--begin::Card title-->
                    <!--begin::Card toolbar-->
                    <div class="col-lg-5 col-md-8 col-sm-12">
                        <!--begin::Toolbar-->

                        <div class="row">
                            <div class="col-md-4">
                                <a data-bs-toggle="modal" data-bs-target="#edit_market"
                                    class="btn bg-app-white  btn-sm  py-2 px-3 mx-1  d-flex align-items-center  justify-content-center edit-market-btn">
                                    <img :src="loadSvg('edit-btn-red.svg')" class="price-edit-btn-icon" />
                                    {{ $t('editPrices') }}
                                </a>
                            </div>
                            <div class="col-md-4">
                                <a @click="isMainTable = true"
                                    :class="isMainTable ? 'bg-app text-white btn-sm py-2  d-flex align-items-center  justify-content-center ' : 'bg-app-white py-2 d-flex align-items-center justify-content-center edit-market-btn'"
                                    class="btn btn-sm  px-3 mx-1">
                                    {{ $t('products') }}
                                </a>
                            </div>
                            <div class="col-md-4">
                                <a @click="isMainTable = false"
                                    :class="!isMainTable ? 'bg-app text-white btn-sm py-2  d-flex align-items-center  justify-content-center ' : ' bg-app-white  py-2 d-flex align-items-center justify-content-center edit-market-btn'"
                                    class="btn btn-sm  px-3 mx-1">
                                    {{ $t('linkedProducts') }}
                                </a>
                            </div>

                        </div>

                        <!--end::Toolbar-->
                    </div>
                    <!--end::Card toolbar-->
                </div>
                <div class="card-body py-4">

                    <main-table v-if="isMainTable" :locale="locale" ></main-table>
                    <variant-table :locale="locale" v-else></variant-table>
                </div>
            </div>
        </div>
    </div>
    <edit-market-modal :marketPlaces="marketPlaces" @handleMarketUpdate="updateMarket"></edit-market-modal>
</template>

<style >
.price-edit-btn-icon {
    margin: 5px;
}

.card-header .btn {
    margin: 10px 0px;
}

@media (max-width: 1375px) {
    .card-header .btn {
        margin: 10px 0px;
        height: 100%;
    }
}

@media (max-width: 767px) {
    .card-header .btn {
        margin: 10px 0px;
        height: 90%;
    }
}
</style>
